module.exports = __webpack_public_path__ + "static/media/iStock-1019963246.8d565952.jpg";